import React from 'react'

import './style.css'

const tooltip = ({ children }) => <div className="tooltip">{children}</div>

export default tooltip
